/**
 * Menú de exportación de un widget.
 */
import React, { useEffect, useRef, useState } from 'react';

const WidgetExportMenu = ({ onPng, onPdf, onExcel, disabled }) => {
    const [open, setOpen] = useState(false);
    const [busy, setBusy] = useState('');
    const rootRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onDoc = (event) => {
            if (!rootRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDoc);
        return () => document.removeEventListener('mousedown', onDoc);
    }, [open]);

    const run = async (key, fn) => {
        setBusy(key);
        try {
            await fn();
            setOpen(false);
        } catch (err) {
            alert(err?.message || 'No se pudo exportar este elemento.');
        } finally {
            setBusy('');
        }
    };

    return (
        <div ref={rootRef} data-export-ignore="true" style={styles.wrap}>
            <button
                type="button"
                style={styles.trigger}
                disabled={disabled || !!busy}
                title="Exportar elemento"
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen(prev => !prev);
                }}
            >
                {busy ? '…' : '⬇'}
            </button>
            {open && (
                <div style={styles.menu} onClick={e => e.stopPropagation()}>
                    <button type="button" style={styles.item} disabled={!!busy} onClick={() => run('png', onPng)}>
                        {busy === 'png' ? 'Generando…' : 'Imagen PNG'}
                    </button>
                    <button type="button" style={styles.item} disabled={!!busy} onClick={() => run('pdf', onPdf)}>
                        {busy === 'pdf' ? 'Generando…' : 'PDF'}
                    </button>
                    <button type="button" style={styles.item} disabled={!!busy} onClick={() => run('xlsx', onExcel)}>
                        {busy === 'xlsx' ? 'Generando…' : 'Excel'}
                    </button>
                </div>
            )}
        </div>
    );
};

const styles = {
    wrap: {
        position: 'absolute',
        top: 6,
        right: 6,
        zIndex: 6
    },
    trigger: {
        width: 28,
        height: 28,
        border: '1px solid #e0d4f7',
        borderRadius: 8,
        background: 'rgba(255,255,255,0.95)',
        color: '#5E35B1',
        cursor: 'pointer',
        fontSize: '0.85rem',
        lineHeight: 1,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
    },
    menu: {
        position: 'absolute',
        top: 32,
        right: 0,
        minWidth: 140,
        background: '#fff',
        border: '1px solid #e0d4f7',
        borderRadius: 8,
        boxShadow: '0 8px 20px rgba(32,33,36,0.12)',
        padding: 4,
        display: 'flex',
        flexDirection: 'column'
    },
    item: {
        border: 'none',
        background: 'transparent',
        textAlign: 'left',
        padding: '8px 10px',
        borderRadius: 6,
        cursor: 'pointer',
        fontSize: '0.8rem',
        color: '#202124'
    }
};

export default WidgetExportMenu;
